import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=4027a203&scoped=true&"
import script from "./alarm.vue?vue&type=script&lang=ts&"
export * from "./alarm.vue?vue&type=script&lang=ts&"
import style0 from "./alarm.vue?vue&type=style&index=0&id=4027a203&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027a203",
  null
  
)

export default component.exports